import {useEffect, useMemo, useRef, useState} from 'react';
import {BehaviorSubject, Observable, skip} from 'rxjs';
import {setRef} from '../render-utils';
import {tryCall} from '../try-call';

export function useBehaviorSubject<T>(subject: BehaviorSubject<T>): T {
	const stream = useMemo(() => subject.pipe(skip(1)), [subject]);
	return useStream(stream, subject.value);
}

export function useStream<T>(stream: Observable<T>, initial?: T): T {
	const [value, setValue] = useState<T>(initial);
	useStreamEffect(stream, setValue);

	return value;
}

export function useStreamEffect<T>(stream: Observable<T>, handler: (value: T) => any) {
	const handlerRef = useRef(handler);
	setRef(handler, handlerRef);
	useEffect(() => {
		const sub = stream.subscribe((value) => tryCall(handlerRef.current, value));
		return () => sub.unsubscribe();
	}, [stream]);
}
